<template>
  <div>
    <component :is="header" :top="top" />
    <!-- getCrumbs.length为0时，不显示面包屑导航 -->
    <!-- <Crumbs v-show="getHasCrumbs && getCrumbs.length" /> -->
    <!-- 有面包屑导航的时候添加class content-has-crumbs是为了控制有无面包屑导航时的页面最小高度 -->
    <div class="content">
      <router-view :top="top"></router-view>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Footer from '../../components/Footer'

import { debounce } from '@/utils/common'

// 首页路径
const INDEX_PATH = '/index'
export default {
  name: 'App',
  components: {
    Footer,
  },
  directives: {},
  data() {
    return {
      top: 0,
      scroll: 0,
    }
  },
  mounted() {
    // 向页面添加股东事件
    window.addEventListener('scroll', this.handleScroll, true)
    window.addEventListener(
      'scroll',
      debounce(this.handleDebounceScroll, 200),
      true
    )
  },
  destroyed() {
    //离开这个界面之后，删除滚动事件，不然容易除bug
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('scroll', this.handleDebounceScroll)
  },
  computed: {
    getHasCrumbs() {
      return this.$store.state.Breadcrumb.hasCrumbs
    },
    getCrumbs() {
      return this.$store.state.Breadcrumb.crumbsList
    },
    header() {
      return INDEX_PATH === this.$route.path ? 'index-header' : 'other-header'
    },
  },
  methods: {
    handleScroll() {
      this.top =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
    },
    // 防抖获取滚动调位置
    handleDebounceScroll() {
      this.scroll =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
    },
  },
}
</script>

<style lang="lass" scoped>
/* .content {
  min-height: calc(100vh-72px-60px);
}
.content-has-crumbs {
  min-height: calc(100vh-72px-60px-30px);
} */
</style>
